webpackJsonp([68],{

/***/ 1302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_helper__ = __webpack_require__(59);



var printReports = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var baseUrl, dateStart, dateEnd, idSubsidiary, name, responseType, cardModel, response, blob;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api' + '/report/kitchen';
						dateStart = this.dateStart;
						dateEnd = this.dateEnd;
						idSubsidiary = this.idSubsidiary;
						name = 'Reporte Cocina';
						responseType = 'blob';
						cardModel = { loadTable: [{}] };
						_context.next = 9;
						return this.$http.post(baseUrl + '?dateStart=' + dateStart + '&dateEnd=' + dateEnd + '&idSubsidiary=' + idSubsidiary, cardModel, { responseType: responseType });

					case 9:
						response = _context.sent;
						blob = helperMethods.generateBlob(response.bodyBlob);

						helperMethods.showDownloadDialog(blob, name, 'pdf');

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function printReports() {
		return _ref.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						params = {
							dateStart: this.dateStart,
							dateEnd: this.dateEnd,
							idSubsidiary: this.idSubsidiary
						};
						_context2.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/report-kitchen', { params: params });

					case 3:
						response = _context2.sent;

						this.loadTable = response.data.data;

					case 5:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadData() {
		return _ref2.apply(this, arguments);
	};
}();

var loadResources = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _ref4, subsidiaries;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/hotel');

					case 2:
						_ref4 = _context3.sent;
						subsidiaries = _ref4.data;

						this.subsidiaries = subsidiaries.data;
						this.idSubsidiary = this.subsidiaries[0].id;

					case 6:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadResources() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var helperMethods = __WEBPACK_IMPORTED_MODULE_3__shared_helper__["a" /* default */].methods;

function customBtn() {
	this.printReports();
}

function onDateFilter(filter) {
	this.value = filter.id;
	if (this.value === 2) {
		this.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["addDays"])(new Date(), 7), 'YYYY-MM-DD');
	} else {
		this.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["addDays"])(new Date(), 0), 'YYYY-MM-DD');
	}
	this.loadData();
}

function created() {
	this.loadResources();
}

function arrowIconStart() {
	var arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconEnd() {
	var arrow = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function data() {
	return {
		value: 1,
		loadTable: [],
		idSubsidiary: '',
		subsidiaries: [],
		subsidiary: 0,
		loading: false,
		menuStart: false,
		dateStart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["subDays"])(new Date(), 0), 'YYYY-MM-DD'),
		dateEnd: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		menuEnd: false,
		date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		filters: [{
			id: 1, value: 1, label: 'Hoy'
		}, {
			id: 2, value: 2, label: 'Semana'
		}]
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'kitchen',
	data: data,
	created: created,
	methods: {
		customBtn: customBtn,
		printReports: printReports,
		onDateFilter: onDateFilter,
		loadData: loadData,
		loadResources: loadResources
	},
	computed: {
		arrowIconStart: arrowIconStart,
		arrowIconEnd: arrowIconEnd
	}
});

/***/ }),

/***/ 1439:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, "td[data-v-e5716c7a]{padding:10px}th[data-v-e5716c7a]{background-color:#545e72;color:#f4f4f4;font-size:12px;padding:10px}tr[data-v-e5716c7a]:nth-child(odd){background-color:hsla(0,0%,95%,.5)}tr[data-v-e5716c7a]:nth-child(2n){background-color:#fff}.table-kitchen[data-v-e5716c7a]{border:1px solid #979797;width:100%}.border-right[data-v-e5716c7a]{border-right:1px solid #d8d8d8}.header-booking-data[data-v-e5716c7a]{height:31px;position:absolute;right:20px;text-align:right;top:50px;width:calc(100% - 230px)}.border-right[data-v-e5716c7a]{border-right:1px solid #7e7e7e}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/reports/Kitchen.vue"],"names":[],"mappings":"AACA,oBACE,YAAc,CACf,AACD,oBACE,yBAA0B,AAC1B,cAAe,AACf,eAAgB,AAChB,YAAc,CACf,AACD,mCACE,kCAA2C,CAC5C,AACD,kCACE,qBAAwB,CACzB,AACD,gCACE,yBAA0B,AAC1B,UAAY,CACb,AACD,+BACE,8BAAgC,CACjC,AACD,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,wBAA0B,CAC3B,AACD,+BACE,8BAAgC,CACjC","file":"Kitchen.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\ntd[data-v-e5716c7a] {\n  padding: 10px;\n}\nth[data-v-e5716c7a] {\n  background-color: #545e72;\n  color: #f4f4f4;\n  font-size: 12px;\n  padding: 10px;\n}\ntr[data-v-e5716c7a]:nth-child(odd) {\n  background-color: rgba(241, 241, 241, 0.5);\n}\ntr[data-v-e5716c7a]:nth-child(even) {\n  background-color: white;\n}\n.table-kitchen[data-v-e5716c7a] {\n  border: 1px solid #979797;\n  width: 100%;\n}\n.border-right[data-v-e5716c7a] {\n  border-right: 1px solid #d8d8d8;\n}\n.header-booking-data[data-v-e5716c7a] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 50px;\n  width: calc(100% - 230px);\n}\n.border-right[data-v-e5716c7a] {\n  border-right: 1px solid #7e7e7e;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1524:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1439);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("1018a062", content, true);

/***/ }),

/***/ 1696:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "xl-2": "",
      "lg2": "",
      "text-xs-right": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.idSubsidiary),
      callback: function($$v) {
        _vm.idSubsidiary = $$v
      },
      expression: "idSubsidiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "d-flex": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "ml-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "md12": "",
      "mt-1": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "disabled": !_vm.dateStart,
      "prepend-icon": "event",
      "append-icon": _vm.arrowIconStart,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md-6": "",
      "pa-0": "",
      "md-2": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "append-icon": _vm.arrowIconEnd,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md12": "",
      "text-xs-right": ""
    }
  }, [_c('section', {
    staticClass: "filters-by-time"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      class: {
        'activeBtn': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.onDateFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(filter.label) + "\n\t\t\t\t\t")])
  }))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.customBtn
    }
  }, [_c('v-icon', [_vm._v("print")]), _vm._v("\n\t\t\t\t\tImprimir Reporte\n\t\t\t\t")], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    staticClass: "checkin-tabs"
  }, [_c('v-tabs-items', [_c('table', {
    staticClass: "table-kitchen",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "border-right"
  }, [_vm._v("Fecha")]), _vm._v(" "), _c('th', {
    staticClass: "border-right"
  }, [_vm._v("Reservas")]), _vm._v(" "), _c('th', {
    staticClass: "border-right"
  }, [_vm._v("In-House")]), _vm._v(" "), _c('th', {
    staticClass: "border-right"
  }, [_vm._v("Check-Out")]), _vm._v(" "), _c('th', [_vm._v("Cantidad de Huéspedes")])]), _vm._v(" "), _vm._l((_vm.loadTable), function(item, index) {
    return _c('tr', {
      key: index,
      on: {
        "actions": _vm.customBtn
      }
    }, [_c('td', {
      staticClass: "border-right"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('td', {
      staticClass: "border-right"
    }, [_vm._v(_vm._s(item.reserve))]), _vm._v(" "), _c('td', {
      staticClass: "border-right"
    }, [_vm._v(_vm._s(item.inHouse))]), _vm._v(" "), _c('td', {
      staticClass: "border-right"
    }, [_vm._v(_vm._s(item.checkout))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total))])])
  })], 2)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1524)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1302),
  /* template */
  __webpack_require__(1696),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e5716c7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/68.587b825d416fe4441b54.js